import script from "./FbPixel.vue?vue&type=script&setup=true&lang=js"
export * from "./FbPixel.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__